import React from "react";
import Box from "@mui/material/Box";
import blueLine from "../../assets/centrum_assets/design/index/vectorBlue.png";
import greenLine from "../../assets/centrum_assets/design/index/vectorGreen.png";

const LinesDecor = ({ greenMt, blueMt, greenScale, blueScale, greenBottom, blueBottom }) => {
  return (
    <>
      {/* GREEN LINE */}
      <Box
        component="img"
        src={greenLine}
        alt="Green decorative line"
        sx={{
          position: { xs: "relative", lg: "absolute" },
          right: 0,
          width: { xs: "150%", sm: "140%", md: "120%", lg: "80%", xl: "65%" },
          zIndex: 6,
          transformOrigin: "bottom right",
          transition: "transform 0.5s ease-in-out",

          // Apply scaling prop, fallback to default
          transform: greenScale ?? {
            xs: "scale(2.4)", sm: "scale(1.5)", md: "scale(1.1)", lg: "scale(.9)", xl: "scale(1)"
          },

          bottom: greenBottom ?? (greenMt === undefined ? { xl: -6, lg: -5, md: -4, sm: -2, xs: 1 } : undefined),
          mt: greenMt,
        }}
      />

      {/* BLUE LINE */}
      <Box
        component="img"
        src={blueLine}
        alt="Blue decorative line"
        sx={{
          position: { xs: "relative", lg: "absolute" },
          left: 0,
          width: { xs: "140%", sm: "130%", md: "110%", lg: "95%", xl: "90%" },
          zIndex: 5,
          transformOrigin: "bottom left",
          transition: "transform 0.5s ease-in-out",
          transform: blueScale ?? {
            xs: "scale(3)", sm: "scale(1.7)", md: "scale(1.3)", lg: "scale(1.2)", xl: "scale(1)"
          },

          bottom: blueBottom ?? (blueMt === undefined ? { xs: "-23%", sm: "-20%", md: "-10%", lg: "-12%", xl: "-9.5%" } : undefined),
          mt: blueMt,
        }}
      />
    </>
  );
};

export default LinesDecor;
